import { IAuthLocalDataRepository, CustomError, TokenType } from '../../index'

export class GetTokenUseCase {
    private localAuthRepository: IAuthLocalDataRepository;

    constructor(localAuthRepository: IAuthLocalDataRepository) {
        this.localAuthRepository = localAuthRepository
    }

    execute(): TokenType | CustomError {
        return this.localAuthRepository.getToken();
    }
}